/* eslint-disable */
export default {
  download: 'Lataa',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
